import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-captcha',
  imports: [FormsModule, MaterialModule, TranslateModule, CommonModule],
  styleUrl: './captcha.component.scss',
  templateUrl: './captcha.component.html',
  host: {
    '[class.landing-style]': "appearance === 'landing'",
    '[class.recovery-style]': "appearance === 'recovery'"
  }
})
export class CaptchaComponent implements OnInit, OnDestroy {
  @ViewChild('captchaCanvas', { static: true }) captchaCanvas!: ElementRef<HTMLCanvasElement>;
  @Input() inputChange?: (value: string) => void;
  @Input() initializeCaptchaCallbacks?: (resetCaptcha?: any, validateCaptcha?: any) => void;
  @Input() captchaLength: number = 5;
  @Input() classInput = "";
  @Input() appearance: 'default' | 'landing' | 'recovery' = 'default';
  langChangeSubscription: Subscription;
  expectedValue: string = '';
  captchaEntered: string = '';
  captchaMismatch: boolean;
  placeHolder: string;
  error: string;
  required: boolean = true;

  constructor(private translateService: TranslateService) { }

  ngOnInit() {
    this.placeHolder = this.translateService.instant('enter CAPTCHA');
    this.langChangeSubscription = this.translateService.onLangChange.subscribe(() => {
      this.placeHolder = this.translateService.instant('enter CAPTCHA');
    });
    this.generateCaptcha();
    this.initializeCaptchaCallbacks?.(this.reset.bind(this), this.validateCaptcha.bind(this));
  }

  reset() {
    this.captchaMismatch = false;
    this.captchaEntered = '';
    this.required = false;
    this.inputChange?.('');
    this.generateCaptcha();
  }

  generateCaptcha() {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
    this.expectedValue = this.makeRandom(possible);
    this.drawCaptcha();
  }

  makeRandom(possible: string): string {
    let text = '';
    for (let i = 0; i < this.captchaLength; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  drawCaptcha() {
    const canvas = this.captchaCanvas.nativeElement;
    const context = canvas.getContext('2d');

    if (context) {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = '#f0f0f0';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.font = '25px Comic Sans MS';
      context.fillStyle = '#000';
      context.fillText(this.expectedValue, 10, 30);
    }
  }

  onInputChange(captchaEntered: string) {
    if (!this.required) this.required = true;
    this.captchaMismatch = false;
    this.inputChange?.(captchaEntered);
  }

  onInputBlur() {
    if (!this.required) this.required = true;
  }

  validateCaptcha(): boolean {
    this.captchaMismatch = this.captchaEntered !== this.expectedValue;
    return !this.captchaMismatch;
  }

  changeCaptcha(event: Event) {
    event.preventDefault();
    this.reset();
  }

  ngOnDestroy() {
    // Unsubscribe from the language change event to prevent memory leaks
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }
}
